import {
  authorizedPost,
  authorizedDelete,
} from "@onsite_app/MobileOrderingMenu/authorizedRequests";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import camelcaseKeys from "camelcase-keys";
import { produce } from "immer";

import { billSplitKeys } from "../queries";
import { addOrderItemClaim, removeOrderItemClaim } from "../reducer";
import { BillSplit, OrderItemClaim, OrderItemClaimSchema } from "../schema";

export const createOrderItemClaim = async ({
  billSplitUuid,
  orderItemUuid,
}: {
  billSplitUuid: string;
  orderItemUuid: string;
}): Promise<OrderItemClaim> => {
  const res = await authorizedPost({
    url: `/v1/bill_splits/${billSplitUuid}/order_item_claims`,
    body: {
      order_item_claim: { order_item_uuid: orderItemUuid },
    },
  });
  const orderItemClaimResponse = camelcaseKeys(res.body.order_item_claim);
  const orderItemClaim = OrderItemClaimSchema.parse(orderItemClaimResponse);
  return orderItemClaim;
};

export const deleteOrderItemClaim = async ({
  billSplitUuid,
  orderItemClaimId,
}: {
  billSplitUuid: string;
  orderItemClaimId: string;
}) => {
  await authorizedDelete({
    url: `/v1/bill_splits/${billSplitUuid}/order_item_claims/${orderItemClaimId}`,
    body: {},
  });
};
export const useDeleteOrderItemClaim = (billSplitSession: BillSplit) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (claim: OrderItemClaim) => {
      const deletedClaim = await deleteOrderItemClaim({
        orderItemClaimId: claim.uuid,
        billSplitUuid: billSplitSession.uuid,
      });
      queryClient.setQueryData(
        billSplitKeys.current(billSplitSession.customerTabId),
        produce(billSplitSession, (draft) => {
          removeOrderItemClaim(draft, claim);
        })
      );
    },
  });
};
export const useCreateOrderItemClaim = (billSplitSession: BillSplit) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (orderItemUuid: string) => {
      const claim = await createOrderItemClaim({
        orderItemUuid,
        billSplitUuid: billSplitSession.uuid,
      });
      queryClient.setQueryData(
        billSplitKeys.current(billSplitSession.customerTabId),
        produce(billSplitSession, (draft) => {
          addOrderItemClaim(draft, claim);
        })
      );
    },
  });
};
